export default __webpack_public_path__ + "428208ff2f9a4b28185b5e9d540f1c7c.svg";